import type { SuburbInput } from "@repo/adapter-core";
import type { SoldOnlyAdapterConfig } from "../shared/sold-only.ts";

// The site filters sold listings with search-kind=sold (status=sold is ignored and returns a mix);
// it also ignores suburb/postcode, so every search returns its whole sold list (284 on 2026-10-13).
export function buildSearchUrl(suburb: SuburbInput, _config: SoldOnlyAdapterConfig): string {
  return `https://www.petrusma.com.au/property-listings/?search-kind=sold&suburb=${encodeURIComponent(suburb.locality)}&postcode=${suburb.postcode}`;
}
